export default "__VITE_ASSET__Bm4QL1ZF__"